import Select from "react-select";
import { useState } from "react";
import { useEffect } from "react";

import { adminDataStore, messageAndErrorStore, triggersStore, userStore } from "../../store/Store";

import Close from "../../assets/close.svg";

import FormButton from "../../formComponents/FormButton";

import { useEscape } from "../../hooks/useEscape";

export default function MergeCompanies({ mergeCompany }) {
  const adminCompanyData = adminDataStore((data) => data.adminCompanyData);
  const setAdminCompanyData = adminDataStore(
    (data) => data.setAdminCompanyData,
  );
  const setCompanyMergeTrigger = triggersStore(
    (data) => data.setCompanyMergeTrigger,
  );
  const JwtToken = userStore((data) => data.JwtToken);
  const currentUser = userStore((data) => data.currentUser);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  const [pending, setPending] = useState(false);
  const [options, setOptions] = useState([]);
  const [mergeWithCompany, setMergeWithCompany] = useState();

  useEffect(() => {
    var arr = [];
    if (adminCompanyData) {
      adminCompanyData.forEach((c) => {
        if (
          (c.company_type_id === 1 || c.company_type_id === 2) &&
          c.id !== mergeCompany.id
        ) {
          arr.push({ value: c.id, label: c.company_name });
        }
      });
      setOptions(arr);
    }
  }, [adminCompanyData, mergeCompany]);

  const handleClose = () => {
    setCompanyMergeTrigger(false);
  };

  useEscape(setCompanyMergeTrigger, [], [], pending);

  const handleSelect = (o) => {
    var c = adminCompanyData.filter((x) => x.id === o.value)[0];
    setMergeWithCompany(c);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setPending(true);
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);

    const reqBody = {
      merge_company: mergeCompany,
      merge_with_company: {...mergeWithCompany},
    };

    reqBody.merge_with_company.updated_by_id = currentUser.id

    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(reqBody),
      signal: controller.signal,
    };
    
    fetch(
      `${process.env.REACT_APP_BACKEND}/admin/merge-companies`,
      requestOptions,
    )
      .then((res) => {
        if (!res.ok) {
          if (res.status === 400) {
            toggleNewMessage("Something went wrong");
            setPending(false);
            return Promise.resolve();
          } else {
            toggleNewMessage("Something went wrong");
            setPending(false);
            return Promise.resolve();
          }
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (!data) {
          return;
        } else {
          setAdminCompanyData(data);
          setPending(false);
          setCompanyMergeTrigger(false);
          toggleNewMessage(null, `${mergeCompany.company_name} merged with ${mergeWithCompany.company_name}`)
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        setPending(false);
        return;
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };

  return (
    mergeCompany && (
      <div className="popup">
        <div className="popup-inner">
          {!pending && (
            <div className="close">
              <img onClick={handleClose} src={Close} alt="close" />
            </div>
          )}
          <h3>{`Merge ${mergeCompany.company_name} With`}</h3>
          <form onSubmit={handleSubmit}>
            <Select
              name="companies"
              options={options}
              onChange={handleSelect}
              placeholder="Select Company"
              value={
                mergeWithCompany
                  ? {
                      value: mergeWithCompany.id,
                      label: mergeWithCompany.company_name,
                    }
                  : ""
              }
              required
            />
            <FormButton pending={pending} name={"Submit"} />
          </form>
        </div>
      </div>
    )
  );
}
